import { render, staticRenderFns } from "./SourceModal.vue?vue&type=template&id=4b2f6f0a&"
import script from "./SourceModal.vue?vue&type=script&lang=js&"
export * from "./SourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports